/**
 * MagicBI Design System - Light Theme
 *
 * Complete light theme configuration with all design tokens
 * and component-specific styling definitions.
 */

import {
  lightThemeColors,
  typography,
  spacing,
  semanticSpacing,
  componentSpacing,
  layoutSpacing,
  shadows,
  borderRadius,
  borderWidth,
  borderStyle,
  semanticBorderRadius,
  componentBorders,
  borderColors,
  duration,
  easing,
  transitions,
  breakpointValues,
  mediaQueries,
  zIndex,
} from "../tokens";
import type { Theme } from "../types/theme";

export const lightTheme: Theme = {
  mode: "light",

  colors: lightThemeColors,

  typography,

  spacing: {
    base: spacing,
    semantic: semanticSpacing,
    component: componentSpacing,
    layout: layoutSpacing,
  },

  shadows,

  borders: {
    radius: borderRadius,
    width: borderWidth,
    style: borderStyle,
    semantic: semanticBorderRadius,
    component: componentBorders,
    colors: borderColors.light,
  },

  transitions: {
    durations: duration,
    easing,
    semantic: transitions,
  },

  breakpoints: {
    values: breakpointValues,
    mediaQueries,
  },

  zIndex,
} as const;

export default lightTheme;
